import React from "react";
import Card from "./Card";

const TONES = {
    brand: {
        iconWrap: "bg-brand-50 text-brand-600",
        label: "text-ink-500",
        value: "text-ink-900",
    },
    danger: {
        iconWrap: "bg-danger-50 text-danger-600",
        label: "text-danger-700",
        value: "text-ink-900",
    },
    success: {
        iconWrap: "bg-success-50 text-success-600",
        label: "text-success-700",
        value: "text-ink-900",
    },
    warning: {
        iconWrap: "bg-warning-50 text-warning-700",
        label: "text-warning-800",
        value: "text-ink-900",
    },
    info: {
        iconWrap: "bg-info-50 text-info-600",
        label: "text-info-700",
        value: "text-ink-900",
    },
};

const StatCard = ({ icon, label, value, tone = "brand", hint }) => {
    const t = TONES[tone] || TONES.brand;
    return (
        <Card className="flex items-center gap-4">
            {icon && (
                <div
                    className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${t.iconWrap}`}
                    aria-hidden="true"
                >
                    {icon}
                </div>
            )}
            <div className="min-w-0">
                <p className={`text-xs font-medium uppercase tracking-wide ${t.label}`}>{label}</p>
                <p className={`mt-1 text-2xl font-semibold ${t.value}`}>{value}</p>
                {hint && <p className="text-xs text-ink-500">{hint}</p>}
            </div>
        </Card>
    );
};

export default StatCard;
